import React from 'react';
import { Item } from '../../items/item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import './style.scss';

export function WallToWallPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    const cssClass = utils.classNames(
        "cms_item",
        "wall-to-wall-panel",
        item.cssClass || item.anchorName || ""
    );

    return (
        <section
            className={cssClass}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
        >
            {subItemsElts}
        </section>
    )
}